export * from './zeiten-mitarbeiter.interface';
